module.exports = __webpack_public_path__ + "2f05fcba1a1f2cabf295f347b20b812f.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/nav_pattern.png
// module id = 479
// module chunks = 0